import { render, staticRenderFns } from "./lands.vue?vue&type=template&id=3c140a1d&"
import script from "./lands.vue?vue&type=script&lang=js&"
export * from "./lands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports